import _ from "lodash";

import { IPrimeTableColumn } from "components/prime-data-table/interfaces";
import { Filters } from "components/prime-data-table";

export const auditForeignKeysColumns = ({ columns, foreignKeys }) => {
    const fieldNames = columns.map((column) => column.field);

    const foreignKeysColumns = foreignKeys
        .map((key) => {
            const camelCaseKey = _.camelCase(key);
            if (fieldNames.find((name) => name.split(".")[0].includes(camelCaseKey))) return false;

            return {
                header: camelCaseKey.firstLetterToUpperCase(),
                field: `foreignKeys.${camelCaseKey}`,
                filterFieldName: `${camelCaseKey}.id`,
                filterBody: Filters.text,
                sortable: true,
                width: 123,
            };
        })
        .filter(Boolean);

    return foreignKeysColumns as IPrimeTableColumn[];
};
